import advDelayLoad from "../../../tv24/js/es6/adv/advDelayLoad";
import advCore from "../../../tv24/js/es6/adv/advCore";
import createCatfish from "./createCatfish";
import destroyMobileBranding from "../destroyAdvBlocks/destroyMobileBranding";

export default function (opt, newsId) {
    if(!showMobileBranding){
        destroyMobileBranding();
        return;
    }

    if(opt.showMobileBrandingOnSecondNews){
        destroyMobileBranding();
    }

    if(document.getElementById('mobileBranding' + newsId) !== null){
        return;
    }

    let headerQuerySelector =
        (opt.subsiteName === '24' || opt.subsiteName === 'lviv' || opt.subsiteName === 'kyivnews') ?
            'header > div.container' : 'header > div.grid-container';

    let headerHeight = (opt.subsiteName === 'lviv' || opt.subsiteName === 'kyivnews') ? 50 : 80;

    if (document.getElementById('mobileBrandingPlace' + newsId) === null) {
        let mobileBrandingWrapper = document.createElement('div');
        mobileBrandingWrapper.id = 'mobileBrandingPlace' + newsId;
        mobileBrandingWrapper.style.zIndex = 9;
        document.querySelector('header').after(mobileBrandingWrapper)
    }

    window.mobileBrandingConfig = {
        mobileBrandingPlace: '#mobileBrandingPlace' + newsId,
        headerHeight: headerHeight,
        isHeaderSticky: true,
        headerQuerySelector: headerQuerySelector
    }

    let mobileBrandingDFPPlace = document.createElement('div');
    mobileBrandingDFPPlace.id = 'mobileBranding' + newsId;
    mobileBrandingDFPPlace.style.display= 'none';
    if(document.getElementById('mobile-branding') != null){
        document.getElementById('mobile-branding').appendChild(mobileBrandingDFPPlace);
    }

    let mobileBrandingTrigger = document.getElementById('mobileBrandingPlace' + newsId) != null ? 'mobileBrandingPlace' + newsId : 'mobile-branding';
    advDelayLoad(function () {
        if(mobileBrandingDFPPlace.getAttribute('inited') === null){
            document.getElementById(mobileBrandingTrigger).style.order = '-2';
            initMobileBranding();
        }
    }, mobileBrandingTrigger, '1px');


    function initMobileBranding() {
        advCore.defineDfpSlot({
            "name": opt.mobileBrandingSlotId,
            "sizes": [[1, 1], [2, 2], [1, 2]],
            "id": 'mobileBranding' + newsId,
            "targeting": opt.dfpTargeting,
            "callback": function (e) {
                if (!e.isEmpty) {
                    if (e.size[0] === 1 && e.size[1] === 2) {
                        destroyMobileBranding();

                        document.addEventListener("MobileBrandingSmallBannerShowed", function () {
                            document.querySelectorAll('.mobileBrandingPlace').forEach(function (node){
                                node.style.top = '0px'
                            });

                            if(document.getElementById('mobile-branding-inline-style') !== null){
                                document.getElementById('mobile-branding-inline-style').remove()
                            }
                        });

                        // document.addEventListener("MobileBrandingSmallBannerClosed", function () {
                        //     contentWrapper.style.paddingTop = rightColPadding + 'px'
                        // });
                        // document.addEventListener("MobileBrandingBigBannerHidden", function () {
                        //     console.log("MobileBrandingBigBannerHidden");
                        // });
                    }
                } else {
                    if(!opt.isMarketplace){
                        createCatfish(opt);
                    }
                    hideMobileBrandingPlace();
                }
            }
        });

        googletag.cmd.push(function () {
            googletag.display('mobileBranding' + newsId);
        });

        mobileBrandingDFPPlace.setAttribute('inited', '');
    }

    function hideMobileBrandingPlace() {
        let mobileBrandingPlace = document.getElementById(mobileBrandingTrigger);
        if (mobileBrandingPlace !== null) {
            mobileBrandingPlace.style.display = 'none'
        }
    }

}